import type { HistoryItem } from '../MatchmakingHistoryPopover';
import { groupHistoryByPeriod } from '../../utils/history.utils';
import { HistorySection } from './HistorySection';

type HistoryContentProps = {
  isLoading: boolean;
  history: HistoryItem[];
  displayLimit: number;
  onSelectHistory: (item: HistoryItem) => void;
  onClose: () => void;
};

export const HistoryContent = ({
  isLoading,
  history,
  displayLimit,
  onSelectHistory,
  onClose,
}: HistoryContentProps) => {
  if (isLoading) {
    return (
      <div className="py-8 text-center text-sm font-termina text-[#6B7280]">
        Loading history...
      </div>
    );
  }

  if (history.length === 0) {
    return (
      <div className="py-8 text-center">
        <p className="text-sm font-termina text-[#6B7280]">
          No search history available for this client yet.
        </p>
        <p className="text-xs font-termina text-[#9CA3AF] mt-2">
          Your search history will appear here once you start searching.
        </p>
      </div>
    );
  }

  const { todayItems, olderItems } = groupHistoryByPeriod(history);
  const displayedToday = todayItems.slice(0, displayLimit);
  const displayedOlder = olderItems.slice(0, displayLimit);

  return (
    <div className="space-y-6">
      <HistorySection
        title="Today"
        items={displayedToday}
        onSelectHistory={onSelectHistory}
        onClose={onClose}
      />
      <HistorySection
        title="Older"
        items={displayedOlder}
        onSelectHistory={onSelectHistory}
        onClose={onClose}
      />
    </div>
  );
};

